import type { Locale } from "@/lib/i18n";
import { pl, type WShopLatestProductsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wShopLatestProductsTranslations: Record<
  Locale,
  WShopLatestProductsTranslations
> = {
  pl,
  en,
  de,
};

export type { WShopLatestProductsTranslations };
